/**
 * S-54 助成金領収書（別記4）一覧・作成／S-55 詳細・編集。
 * 画面構成は報告書兼請求書と同一のため invoices の部品を種別「領収書」で使う。
 */
import { StatementDetailPage } from '../invoices/StatementDetailPage';
import { StatementListPage } from '../invoices/StatementListPage';

export function ReceiptListPage() {
  return <StatementListPage type="領収書" />;
}

export function ReceiptDetailPage() {
  return <StatementDetailPage type="領収書" />;
}
